import React, { useContext, useEffect, useState } from "react";
import { Title, Text } from "rizzui/typography";
import { Button, Input, Password } from "rizzui";
import AccountBox from "../../component/accountBox";
import { useForm } from "react-hook-form";
import SocialLogin from "../../component/socialsLogIn";
import { emailValidationPattern } from "./signup";
import { useLocation, useNavigate } from "react-router";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { AuthContext } from "../../context/authContext";
import { inputClassName, labelClassName } from "../projects/new/first";

export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export default function Login() {
  const location = useLocation();
  const [message] = useState(location?.state?.message);

  useEffect(() => {
    document.title = "Log in";
  }, []);

  const { currentEmail } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: {
      email: currentEmail,
      password: "",
    },
  });

  const navigate = useNavigate();
  const {
    data: token,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["login"],
    queryFn: async () => {
      const { email, password } = getValues();
      return axios
        .post(`${baseUrl}/auth/login`, {
          email,
          password,
        })
        .then((response) => {
          const isLogin = response.data ? "true" : "false";
          localStorage.setItem("isLogin", isLogin);
          localStorage.setItem("token", response.data.token);
          if (response.data.token) navigate("/");
          return response;
        })
        .catch((e) => {
          return Promise.reject(
            new Error(
              e.response?.data?.details?.message ?? "Invalid Credentials"
            )
          );
        });
    },
    retry: 0,
    enabled: false,
  });

  const handleLogin = handleSubmit((data) => {
    refetch();
  });

  return (
    <AccountBox>
      <div className="flex flex-col gap-[32px]">
        <div>
          <Title className="text-[18px] leading-[23.4px] font-[600] text-primary-dark mb-[8px] font-ibmPlexSerif">
            Log in to your account
          </Title>
          <Text className="text-[14px] leading-[18.48px] font-[400] text-secondary-dark font-switzer">
            Log in to your account to automate your customer outreach
          </Text>
        </div>

        <div className="text-secondary-dark font-switzer">
          <SocialLogin />
          {message === "password-changed" && (
            <Text className="font-switzer text-[13px] -mt-[28px] mb-4 text-[#00A861]">
              Your password was changed successfully. Please log in again to
              continue.
            </Text>
          )}

          {message === "session-expired" && (
            <Text className="font-switzer text-[13px] -mt-[28px] mb-4 text-[#E63946]">
              Session expired. Please log in to continue.
            </Text>
          )}
          <form
            onSubmit={handleLogin}
            noValidate
            className="flex flex-col gap-[24px]"
          >
            <Input
              type="email"
              label="Email Address"
              variant="text"
              rounded="md"
              inputClassName={inputClassName}
              labelClassName={labelClassName}
              {...register("email", {
                ...emailValidationPattern,
              })}
              error={errors.email?.message ? errors.email.message : ""}
            />

            <Password
              label={
                <Text>
                  Password{" "}
                  <a
                    href="/account/forgotpassword"
                    className="text-primary-dark font-semibold float-right"
                  >
                    Forgot Password
                  </a>
                </Text>
              }
              variant="text"
              rounded="md"
              labelClassName={labelClassName}
              inputClassName={inputClassName}
              {...register("password", {
                required: true,
              })}
              error={
                errors.password?.type === "required"
                  ? "Password is required"
                  : ""
              }
            />

            <Button
              variant="solid"
              className="!bg-btn rounded-[4px] w-full  !text-[12px] !font-switzer !font-[500]"
              isLoading={isLoading}
              type="submit"
            >
              Log in
            </Button>
            <Text className="text-[#E63946] font-switzer text-[13px] mt-[-20px] mb-[8px]">
              {error?.message}
            </Text>
          </form>
        </div>

        {/*   <Text className="text-center leading-[18.48px] text-[14px] text-secondary-dark font-switzer">
          Don’t have an account?{" "}
          <a href="signup" className="font-semibold underline">
            Create an account
          </a>
        </Text> */}
      </div>
    </AccountBox>
  );
}
